export const getEmploymentTypeEntries = ({
  jobRole,
  jobRoleDeslugified,
  formatMessage,
}: {
  jobRole: string;
  jobRoleDeslugified: string;
  formatMessage: (
    message: { id: string },
    values: { jobRole: string }
  ) => string;
}): Array<{ displayName: string; url: string }> => [
  {
    displayName: formatMessage(
      { id: 'CRATE_MASTER_DIRECTORY_JOB_ROLE_PART_TIME' },
      { jobRole: jobRoleDeslugified }
    ),
    url: `/jobs/k-teilzeit/t-${jobRole}`,
  },
  {
    displayName: formatMessage(
      { id: 'CRATE_MASTER_DIRECTORY_JOB_ROLE_STUDENT' },
      { jobRole: jobRoleDeslugified }
    ),
    url: `/jobs/k-student/t-${jobRole}`,
  },
  {
    displayName: formatMessage(
      { id: 'CRATE_MASTER_DIRECTORY_JOB_ROLE_FREELANCE' },
      { jobRole: jobRoleDeslugified }
    ),
    url: `/jobs/k-freiberuflich/t-${jobRole}`,
  },
  {
    displayName: formatMessage(
      { id: 'CRATE_MASTER_DIRECTORY_JOB_ROLE_TEMP_JOBS' },
      { jobRole: jobRoleDeslugified }
    ),
    url: `/jobs/k-aushilfe/t-${jobRole}`,
  },
];
